/**
 * ConsoleNav — where the console is mounted and how to move within it,
 * for pages that link to other pages.
 *
 * AdminLayout provides it (it owns `basePath` and sits inside the router).
 * Pages read it with useConsoleNav() and render an ordinary <a href> that
 * navigates in-app when the context is present — the same href + navigate
 * pattern ApprovalsBell uses. Outside the layout (component tests mount pages
 * without a router; the repo root's React 19 and this package's React 18
 * cannot share react-router's context) the hook returns null and the anchor
 * is a plain link. Pages must not import react-router hooks directly for
 * that reason.
 */
import { createContext, useContext } from 'react';
export const ConsoleNavContext = createContext(null);
export function useConsoleNav() {
    return useContext(ConsoleNavContext);
}
/** Href to a console page: `${basePath}/<page>?<query>` when the layout is present, else guessed from the current URL. */
export function consoleHref(nav, page, query) {
    const base = nav ? nav.basePath : (typeof window === 'undefined' ? '' : guessBaseFromPath(window.location.pathname));
    const qs = query ? new URLSearchParams(query).toString() : '';
    return `${base}/${page}${qs ? `?${qs}` : ''}`;
}
/** Without the layout, the console base is whatever precedes the current page segment ('/platform/apps' → '/platform'). */
export function guessBaseFromPath(pathname) {
    const trimmed = pathname.replace(/\/+$/, '');
    const i = trimmed.lastIndexOf('/');
    return i > 0 ? trimmed.slice(0, i) : '';
}
//# sourceMappingURL=consoleNav.js.map